import axios from 'axios';

const api = axios.create({
  baseURL: 'http://fuanbio.com:9000/api'
});

export function getPeptides() {
  return api.get('/');
}

export function addPeptide(data) {
  return api.post('/', data);
}

// 多肽计算器接口
export function calculatePeptide(data) {
  return api.post('/peptide/search', null, { params: data });
}

// 肽含量计算接口
export function calculatePeptideContent(data) {
  return api.post('/peptide/component', null, { params: data });
}
 